module.exports = __webpack_public_path__ + "img/icon-profile.291a7463.png";